import groq from 'groq'
import pageFields from '../fields/page'
import productFields from '../fields/product'
import mediaField from '../fields/media'
import socialMediaField from '../fields/social-media'
import linkField from '../fields/link'
import imageField from '../fields/image'

export default (slug, id, alt) => {
  let query
  if (id) {
    query = `_id == "${id}"`
  } else {
    query = `_type == "productCategory" && slug.current == "${slug}"`
  }
  return groq`
    *[${query}][0]{
      ...${pageFields},
      cbd,
      introTitle,
      introHero{
        ...${mediaField}
      },
      backgroundColors[] {
        ...
      },
      backgroundImages[] {
        ...,
        asset-> {
          ...
        }
      },
      introText,
      introMedia[]{
        ...${socialMediaField}
      },
      nonCBDIntroMedia[]{
        ...${socialMediaField}
      },
      defined(introCta.page) || defined(introCta.url) => {
        "introCta": introCta{
          ...${linkField}
        }
      },
      outroTitle,
      outroText,
      defined(outroCta.page) || defined(outroCta.url) => {
        outroCta{
          ...${linkField}
        }
      },
      outroImage {
        ...${imageField}
      },
      marquees,
      "products": products[]->{
        ...${pageFields},
        ...${productFields}
      },
      featuredProducts{
        title,
        text,
        products[]->{
          ...${pageFields},
          ...${productFields}
        },
        defined(cta.page) || defined(cta.url) => {
          "cta": cta{
            ...${linkField}
          }
        }
      },
      ingredients{
        cbd,
        title,
        subTitle
      }
    }
  `
}
